import { Container, ToggleContainer } from './CategoryToggle.styles';
import { FunctionalComponent, h } from 'preact';
import { CategoryProps } from '../../CategoryHandler/MapCategories';
import Toggle from '../Toggle/Toggle';

const CategoryToggle: FunctionalComponent<CategoryProps> = ({ category, checked, onCategoryToggle }) => {
  return (
    <Container data-testid="uc-category-toggle">
      <ToggleContainer>
        <Toggle
          checked={checked}
          id={category.slug}
          isDisabled={category.isEssential}
          label={category.label}
          onToggle={onCategoryToggle}
        />
      </ToggleContainer>
    </Container>
  );
};

export default CategoryToggle;
